/*
 * Copyright (c) 2008-2025 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import Vue from "vue"
import api from "@/config/api"

export default {
  namespaced: true,

  state: {
    stats: {},
    status: null,
    lastLoadStatus: false,
    lastLoadTime: null,
  },

  mutations: {
    /**
     * commit loading process to state
     */
    loading(state) {
      state.status = "loading"
    },

    /**
     * commit loaded statistics to state
     *
     * @param stats
     */
    loaded(state, stats) {
      state.stats = stats
      state.status = "success"
      state.lastLoadStatus = "success"
      state.lastLoadTime = new Date()
    },

    /**
     * commit load error to state
     */
    loadError(state) {
      state.status = "error"
      state.lastLoadStatus = "error"
    },
  },

  actions: {
    /**
     * load statistics from server
     * @param {Array} metrics
     * @returns {Promise<any[]>}
     */
    load({ commit }, metrics) {
      return new Promise((resolve, reject) => {
        commit("loading")
        Vue.http.get(api.SERVER_STATISTICS(metrics)).then(
          (response) => {
            commit("loaded", response.body)
            resolve(response)
          },
          (error) => {
            commit("loadError")
            reject(error)
          }
        )
      })
    },
  },

  getters: {
    /**
     * Get stats object
     *
     * @returns {any[]}
     */
    stats: (state) => state.stats,

    /**
     * Get whether data is available
     *
     * @returns {boolean}
     */
    dataAvailable: (state) => state.lastLoadStatus == "success",

    /**
     * Get date of last refresh
     *
     * @returns {Date}
     */
    lastRefresh: (state) => state.lastLoadTime,
  },
}
